import { jsx as t, jsxs as c, Fragment as l } from "react/jsx-runtime";
import { d as $, al as q, j as y } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as B } from "react";
import { stupidInvertClasses as C } from "../../utils/index.js";
import { getButtonStyles as N } from "../BaseButton/index.js";
import { BaseIcon as u } from "../BaseIcon/index.js";
import { isIconName as f } from "../BaseIcon/typeGuards.js";
import { DotProgress as W } from "../DotProgress/index.js";
import { withTooltip as j } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index14.css';const P = "_button_m0uq1_1", w = "_fullWidth_m0uq1_23", R = "_sm_m0uq1_33", S = "_md_m0uq1_37", A = "_pendingContent_m0uq1_46", n = {
  button: P,
  fullWidth: w,
  sm: R,
  md: S,
  pendingContent: A
}, J = j(
  B(
    ({
      isPendingAriaLabel: _ = "Loading",
      size: e = "md",
      fullWidth: g = !1,
      variant: h,
      href: i,
      startIcon: r,
      endIcon: s,
      children: b,
      __inverted: v,
      type: x = "button",
      ...o
    }, a) => {
      const d = $(
        N({
          size: e,
          variant: h ?? (i ? "secondary" : "primary"),
          ...o
        }),
        n.button,
        n[e],
        g ? n.fullWidth : void 0,
        v ? C() : void 0
      ), m = /* @__PURE__ */ c(l, { children: [
        f(r) && /* @__PURE__ */ t(u, { icon: r, size: "md" }),
        b,
        f(s) && /* @__PURE__ */ t(u, { icon: s, size: "md" })
      ] });
      return typeof i == "string" ? /* @__PURE__ */ t(
        q,
        {
          ...p(o),
          href: i,
          className: d,
          "data-component": "Button",
          ref: a,
          children: m
        }
      ) : /* @__PURE__ */ t(
        y,
        {
          ...p(o),
          type: x,
          "data-active": o.isActive ? "true" : void 0,
          className: d,
          "data-component": "Button",
          ref: a,
          children: o.isPending ? /* @__PURE__ */ c(l, { children: [
            /* @__PURE__ */ t("span", { className: n.pendingContent, "aria-hidden": "true", children: m }),
            /* @__PURE__ */ t(W, { "aria-label": _, size: e })
          ] }) : m
        }
      );
    }
  )
);
export {
  J as Button
};
